import Config from 'services/config/local';
import Alert from './alert.class';

// noinspection JSUnresolvedVariable,Eslint
if (!ENVIRONMENT || ['development', 'test'].indexOf(ENVIRONMENT)) {
    require('./alerts.json'); // eslint-disable-line global-require
}

/**
 * Response parser
 * @param {{data:Object|Array}} response - Response object
 * @returns {Array|Object}
 */
function responseDataExtractor(response) {
    const data = response.data;

    data.objects = data.objects.map(thing => new Alert(thing));

    return data;
}

/**
 * AlertsApi class.
 */
export default class AlertsApi {
    /**
     * @param {$http} $http - Angular $http service
     * @constructor
     * @ngInject
     */
    constructor($http) {
        /** @type {$http} */
        this.$http = $http;
        /** @type {Object} */
        this.config = Config.api.alerts;
    }

    /**
     * Get Alerts
     * @returns {promise}
     */
    getList() {
        return this.$http.get(this.config.listUrl).then(responseDataExtractor);
    }

}



// WEBPACK FOOTER //
// ./app/services/api/alerts/alerts.service.js